export default "/images/candy-storage.png?4bbb295b7d0f02f62e4c0a7ee4c97b56";